import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ComentariosService } from 'src/app/_components/glm-comentarios/comentarios.service';
import { RetroalimentacionDialogoComentarioComponent } from '../../retroalimentacion/retroalimentacion-dialogo-comentario/retroalimentacion-dialogo-comentario.component';
import { ConfiguracionAutoevaluacion } from '../configuracion-autoevaluacion';

@Component({
  selector: 'app-autoevaluacion-notificacion-alumno',
  standalone: false,
  templateUrl: './autoevaluacion-notificacion-alumno.component.html',
  styleUrls: ['./autoevaluacion-notificacion-alumno.component.scss', '../../unidad-etapas/unidad-evento/unidad-evento.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoevaluacionNotificacionAlumnoComponent implements OnInit {

  @Input()
  autoevaluacion: ConfiguracionAutoevaluacion;
  @Input()
  unidadEventoMateriaId: number;
  @Input()
  fechaAplicar: string;

  @Input()
  alumnoId: number;

  constructor(private route: ActivatedRoute, private comentariosService: ComentariosService, private matDialogRef: MatDialog) { }

  ngOnInit(): void {

  }

}
